"use strict";
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

'use client';

exports.__esModule = true;
exports.default = void 0;
var _AssetRegistry = require("../../modules/AssetRegistry");
var AssetRegistry = {
  registerAsset: _AssetRegistry.registerAsset,
  getAssetByID: _AssetRegistry.getAssetByID
};
var _default = exports.default = AssetRegistry;
module.exports = exports.default;